module.exports = __webpack_public_path__ + "img/chess-rook.51c2b503.svg";